<div class="flex-row flex" style="overflow-x: auto">
    <div class="cb-padding-left-3x cb-padding-right-3x cb-padding-bottom-3x flex-col flex-100">
        <div class="start-center flex-row">
            <h3 class="mat-headline-6 flex">Document Types</h3>
            <button mat-raised-button (click)="newItemClicked()" color="primary">
                Add New Document Type
            </button>
        </div>
        <cb-table [loaded]="true" [stringColumns]="columns">
            @for (result of searchResults; track result) {
                <tr cbTableRow>
                    <td class="flex flex-row start-center">
                        <div>{{ result.label }}</div>
                        @if (result.description) {
                            <cb-info-popup [tooltip]="result.description"></cb-info-popup>
                        }
                    </td>
                    <cb-td-text [value]="result.codeName"></cb-td-text>
                    <cb-td-text [value]="result.fileTypes.join(', ')"></cb-td-text>
                    <cb-td-text [value]="result.maximumFileSizeInMegaBytes"></cb-td-text>
                    <cb-td-checkbox [value]="result.isActive"></cb-td-checkbox>
                    <td cbTableStickyCol="end" cbTableShrinkCol>
                        <button
                            class="cb-margin-right"
                            mat-icon-button
                            (click)="editItemClickedForDto(result)"
                        >
                            <mat-icon> edit </mat-icon>
                        </button>
                        <button mat-icon-button (click)="deleteItem(result)">
                            <mat-icon> delete </mat-icon>
                        </button>
                    </td>
                </tr>
            }
        </cb-table>
    </div>
</div>
